export const HELP_BAR_ITEM_NAME = 'Search all resources';
